import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
* Stayntouch
*/
const factory = function factory({ window, document, thn }) {
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.srp-hotel-item'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room?.querySelector('.head-block-content h3')?.textContent?.split('(')?.[0].trim();
            if (!roomName) {
                return null;
            }
            const roomType = getRoomType(roomName ?? undefined);
            const ratesInfo = Array.from(room.querySelectorAll('.srp-room-types')).map((rate) => {
                const rateName = rate.querySelector('.rate-name-block h4')?.textContent || '';
                const ratePrice = thn.parseNumber(room.querySelector('.price')?.textContent);
                const hasBreakfast = !!rateName.match(/breakfast|frühstück/i);
                const isRefundable = true;
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            const roomData = {
                name: roomName,
                adults: numAdults,
                children: numChildren,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            // https://hotelstefanie.ibe.stayntouch.com/search-results?checkin=05-19-2025&checkout=05-21-2025&adults=2&kids=1
            const validUrl = url.hostname.match(/search-results/);
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            url.searchParams.set('checkin', '[date_begin]');
            url.searchParams.set('checkout', '[date_end]');
            url.searchParams.set('adults', '[adults]');
            url.searchParams.set('kids', '[children]');
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$2/$3');
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            const travelInfo = window.localStorage?.travelInfo
                ? JSON.parse(window.localStorage.travelInfo)
                : {};
            // Dates
            const dateBegin = String(thn.parseUrlParameter('checkin') ?? travelInfo?.startDate).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
            const dateEnd = String(thn.parseUrlParameter('checkout') ?? travelInfo?.endDate).replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$1/$2');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Guests, Adults & Children
            const adults = thn.parseNumber(String(thn.parseUrlParameter('adults') ?? travelInfo?.adult)) ?? 2;
            const children = thn.parseNumber(String(thn.parseUrlParameter('kids') ?? travelInfo?.child)) ?? 0;
            // Prices & Currency || No Rooms
            const pricesArray = Array.from(document.querySelectorAll('.price'));
            const prices = pricesArray.map((el) => thn.parseNumber(el.textContent)).filter((value) => value !== null);
            const price = Math.min(...prices);
            const currency = thn.parseCurrency(pricesArray?.[0]?.textContent);
            const noAvailability = document.querySelector('.no-room-found-block') || thn.empty(prices);
            if (price && currency) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    price,
                    currency,
                    roomDetails: roomDetailsParseData(adults, children),
                };
            }
            if (noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingId = document.querySelector('.confirm-cell span')?.textContent || '';
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const datesString = document.querySelector('.checkout-blk')?.childNodes || [];
            const checkinStr = datesString?.[0]?.textContent?.split(':')?.[1]?.trim() || '';
            const checkoutStr = datesString?.[2]?.textContent?.split(':')?.[1]?.trim() || '';
            const dateBegin = checkinStr ? String(translateDate(checkinStr, thn.data.language)) : '';
            const dateEnd = checkoutStr ? String(translateDate(checkoutStr, thn.data.language)) : '';
            const price = thn.parseNumber(document.querySelector('.grand-total-amount div:not(.heading)')?.textContent);
            const currency = thn.parseCurrency(document.querySelector('.grand-total-amount div:not(.heading)')?.textContent);
            const adults = thn.parseNumber(document.querySelector('.adult-inner')?.textContent) || 2;
            const children = thn.parseNumber(document.querySelector('.child-inner')?.textContent) || 0;
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
                adults,
                children,
            };
        },
    };
};

export { factory };
